import { Injectable } from '@angular/core';
// if you update angular to version >= 14. please change package to '@sentry/angular'
import * as Sentry from '@sentry/angular-ivy';

@Injectable()
export class CustomSentryErrorHandler extends Sentry.SentryErrorHandler {
  constructor() {
    super({ showDialog: false });
  }

  override handleError(error: any): void {
    // error case deploy โค้ดใหม่ แล้วมี cache เก่าอยู่ใน browser จะทำการ reload ใหม่
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error?.message)) {
      window.location.reload();
      return;
    }

    super.handleError(error);
  }
}
